import { Affix, Col, Form, Row, Space, Spin } from "antd";
import { isEmpty } from "lodash";
import Page403 from "pages/PageError/403";
import { useState } from "react";
import EmptyCart from "../EmptyCart";
import InfoAgent from "../InfoAgent";
import InfoProductAndBill from "../InfoProductAndBill";
import InvalidShippingTypePopup from "../InvalidShippingTypePopup";
import ModalCreateOrder from "../ModalCreateOrder";
import TabsCart from "../TabsCart";
import "./index.scss";
import useList from "./useList";

const List = ({ useInOrder = {} }) => {
  const {
    cartPermissions,
    onChangeTab,
    data,
    loading,
    form,
    dataInfoAgent,
    dataInfoProductAndBill,
    handleUpdate,
    handleUpdateSeller,
    refetchCart,
    handleUpdateItem,
    handleAddNewItems,
    handleRemoveCartItem,
    handleVatAllItems,
    handleApplyCashPaymentMethod,
    handleCancelApplyCashPaymentMethod,
    loadingUpdateCart,
    hasCart,
    isEmptyCart,
    carts,
    loadingGetAllCarts,
    dataShippingProvider,
    loadingShippingProvider,
    shippingTypes,
    invalidShippingTypePopup,
    closeInvalidShippingTypePopup,
  } = useList({ useInOrder });
  const [warehouses, setWarehouses] = useState();

  const onGetWarehouses = (value) => {
    setWarehouses(value);
  };
  const { canCreateCart, canViewCart } = cartPermissions;

  if (!loading && !canViewCart) {
    return <Page403 />;
  } else {
    return (
      <Spin spinning={loading}>
        <Space direction="vertical" style={{ width: "100%", height: "100%" }}>
          {isEmpty(useInOrder) && (
            <TabsCart
              canCreateCart={canCreateCart}
              onChangeTab={onChangeTab}
              hasCart={hasCart}
              carts={carts}
              loadingGetAllCarts={loadingGetAllCarts}
              warehouses={warehouses}
              onGetWarehouses={onGetWarehouses}
            />
          )}
          {isEmptyCart && isEmpty(useInOrder) ? (
            <EmptyCart />
          ) : (
            <>
              <Form size="middle" colon={false} form={form}>
                <Row gutter={[16, 8]}>
                  <Col span={24}>
                    <InfoAgent
                      data={dataInfoAgent}
                      dataOrder={data}
                      handleUpdate={handleUpdate}
                      handleUpdateSeller={handleUpdateSeller}
                      loadingUpdateCart={loading}
                      refetchCart={refetchCart}
                      useInOrder={useInOrder}
                      dataShippingProvider={dataShippingProvider}
                      form={form}
                      loadingShippingProvider={loadingShippingProvider}
                      shippingTypes={shippingTypes}
                    />
                  </Col>

                  <Col span={24}>
                    <InfoProductAndBill
                      data={dataInfoProductAndBill}
                      handleUpdate={handleUpdate}
                      refetchCart={refetchCart}
                      handleUpdateItem={handleUpdateItem}
                      handleAddNewItems={handleAddNewItems}
                      handleRemoveCartItem={handleRemoveCartItem}
                      handleVatAllItems={handleVatAllItems}
                      onApplyCashPaymentMethod={handleApplyCashPaymentMethod}
                      onCancelApplyCashPaymentMethod={handleCancelApplyCashPaymentMethod}
                      loadingApplyCashPaymentMethod={loadingUpdateCart}
                      useInOrder={useInOrder}
                    />
                  </Col>
                </Row>
              </Form>
              {isEmpty(useInOrder) && (
                <Affix offsetBottom={10}>
                  <Space
                    style={{
                      background: "#FFFFFF",
                      width: "100%",
                      display: "flex",
                      justifyContent: "end",
                      padding: "8px 8px",
                      borderRadius: 8,
                    }}
                  >
                    <ModalCreateOrder data={data} form={form} shippingTypes={shippingTypes} />
                  </Space>
                </Affix>
              )}
            </>
          )}
        </Space>
        <InvalidShippingTypePopup
          visible={invalidShippingTypePopup?.visible}
          message={invalidShippingTypePopup?.message}
          onClose={closeInvalidShippingTypePopup}
        />
      </Spin>
    );
  }
};

export default List;
